import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-dropdown-multiselect',
  templateUrl: './dropdown-multiselect.component.html',
  styleUrls: ['./dropdown-multiselect.component.scss']
})
export class DropdownMultiselectComponent implements OnInit, OnChanges {
  @Input() itemsData: any = [];
  @Input() bindLabel: string = 'value';
  @Input() bindValue: string = 'id';
  @Input() isBindValueNumeric: boolean = false;
  @Input() isShowValueInLabel: boolean = false;
  @Input() isInitiallySelectAll: boolean = false;
  @Input() selectInitialItem: string;
  @Output() changemultiselect: EventEmitter<any> = new EventEmitter<any>();
  @Input() isSelectionKeepSameForSearch: boolean = false;

  selectedValues = [];
  selectAllChk = false;
  searchText = '';

  constructor() { }

  ngOnInit(): void {
    this.assignSelectAllChk();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.itemsData !== undefined && changes.itemsData.previousValue !== undefined && changes.itemsData.currentValue !== undefined && changes.itemsData.previousValue != changes.itemsData.currentValue) || (changes.selectInitialItem !== undefined && changes.selectInitialItem.previousValue !== undefined && changes.selectInitialItem.currentValue !== undefined && changes.selectInitialItem.previousValue != changes.selectInitialItem.currentValue)) {
      this.assignSelectAllChk();
    }
  }

  assignSelectAllChk() {
    let selectedData = this.selectInitialItem && this.selectInitialItem.length > 0 ? (this.isBindValueNumeric ? this.selectInitialItem.split(",").map(Number) : this.selectInitialItem.split(',')) : [];
    if (this.searchText) {
      const newList = this.itemsData
        .filter(x => this.isShowValueInLabel ?
          x[this.bindLabel].toString().toLocaleLowerCase().indexOf(this.searchText) > -1 || x[this.bindValue].toString().toLocaleLowerCase().indexOf(this.searchText) > -1 :
          x[this.bindLabel].toString().toLocaleLowerCase().indexOf(this.searchText) > -1
      ).map((x) => x[this.bindValue]);

      const selectedSet = new Set<string | number>(selectedData);
      if (this.isSelectionKeepSameForSearch) {
        var searchSelectedData = newList.filter((x: string | number) => selectedSet.has(x));

        const finalSelection = Array.from(
          new Set([...selectedData, ...searchSelectedData])
        );
        selectedData = finalSelection;
      }
      else {
        selectedData = newList.filter((x: string | number) => selectedSet.has(x));
      }
    }

    if (this.isInitiallySelectAll && this.itemsData.length > 0) {
      this.selectAllChk = this.isInitiallySelectAll;
      this.selectAllItems();
    }
    else if ((!this.isInitiallySelectAll) && (this.itemsData.length > 0) && selectedData.length > 0 && (this.itemsData.length === selectedData.length)) {
      this.selectAllChk = true;
      this.selectAllItems();
    }
    else if ((!this.isInitiallySelectAll) && (this.itemsData.length > 0) && selectedData.length > 0) {
      this.selectedValues = selectedData;
      this.selectAllChk = false;
    }
    else if ((!this.isInitiallySelectAll) && (this.itemsData.length > 0) && selectedData.length === 0) {
      this.unselectAllItems();
    }
  }

  toggleCheckAll(values: any) {
    if (values.currentTarget.checked) {
      this.selectAllItems();
    } else {
      this.unselectAllItems();
    }
  }

  onOpen() {
    setTimeout(() => {
      const scrollContainer = document.querySelector('.ng-dropdown-panel-items');
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
    }, 0);
  }

  private selectAllItems() {
    if (this.searchText === '') {
      const newList = this.itemsData.map((x) => x[this.bindValue]);
      this.selectedValues = [...newList];
        this.selectAllChk = true;
    } else {
      const newList = this.itemsData
        .filter(x => this.isShowValueInLabel ?
          x[this.bindLabel].toString().toLocaleLowerCase().indexOf(this.searchText) > -1 || x[this.bindValue].toString().toLocaleLowerCase().indexOf(this.searchText) > -1 :
          x[this.bindLabel].toString().toLocaleLowerCase().indexOf(this.searchText) > -1
        ).map((x) => x[this.bindValue]);

      if (this.isSelectionKeepSameForSearch) {
        this.selectedValues = Array.from(
          new Set([...this.selectedValues, ...newList])
        );
        if (this.selectedValues.length === this.itemsData.length) {
          this.selectAllChk = true;
        }
        else {
          this.selectAllChk = false;
        }
      }
      else {
        this.selectedValues = [...newList];
        this.selectAllChk = false;
      }
    }
  }

  private unselectAllItems() {
    if (this.searchText && this.isSelectionKeepSameForSearch) {
      const newList = this.itemsData
        .filter(x => this.isShowValueInLabel ?
          x[this.bindLabel].toString().toLocaleLowerCase().indexOf(this.searchText) > -1 || x[this.bindValue].toString().toLocaleLowerCase().indexOf(this.searchText) > -1 :
          x[this.bindLabel].toString().toLocaleLowerCase().indexOf(this.searchText) > -1
        ).map((x) => x[this.bindValue]);

      const newListSet = new Set<string | number>(newList);

      this.selectedValues = this.selectedValues.filter(
        (x: string | number) => !newListSet.has(x)
      );
    }
    else {
      this.selectedValues = [];  
    }
    this.selectAllChk = false;
  }

  changeSelection(event) {
    if (event && event.length != undefined && event.length !== this.itemsData.length) {
      this.selectAllChk = false;
    } else if (event && event.length != undefined && event.length === this.itemsData.length) {
      this.selectAllChk = true;
    }
    this.changemultiselect.emit(this.selectedValues);
  }

  getLabelText(item: any) {
    if (item) {
      return this.isShowValueInLabel ? `${item[this.bindValue]} - ${item[this.bindLabel]}` : item[this.bindLabel];
    }
  }

  close(event) {
    this.searchText = '';
  }

  search(event) {
    this.searchText = event.term.toLocaleLowerCase();
  }

  ddlOptionsSearch = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return this.isShowValueInLabel ?
      item[this.bindLabel].toLocaleLowerCase().indexOf(term) > -1 || item[this.bindValue].toString().toLocaleLowerCase().indexOf(term) > -1 :
      item[this.bindLabel].toLocaleLowerCase().indexOf(term) > -1;
  };
}
